import { useMemo, useState } from "react";
import { useIntlFormatterLocales } from "./useIntlFormatterLocales";

export function useFormatNumber(
  maximumFractionDigits = 2,
  options: Intl.NumberFormatOptions = {}
) {
  const locales = useIntlFormatterLocales();
  const [initialOptions] = useState(options);
  const formatter = useMemo(
    () =>
      new Intl.NumberFormat(locales, {
        maximumFractionDigits,
        ...initialOptions,
      }).format,
    [initialOptions, locales, maximumFractionDigits]
  );
  return formatter;
}
